import TermsOfService from './tos.presenter';
import { IContentsContentElem } from 'app-template-lib/utils';
import { TContentsContentParams } from '../../..//shared/t-contents-params';
import ColumnLayout from '../column-layout';

export default function TermsOfServicePage({ }: IContentsContentElem<TContentsContentParams>) {
    return (
        <ColumnLayout>
            <TermsOfService/>
        </ColumnLayout>
    );
}
